import axios, { AxiosResponse } from 'axios';
import { BaseResponse } from 'models/baseResponse';
import store from 'cache/store';
const urlApi = process.env.REACT_APP_URL_XD;

const axiosInstance = axios.create({
    baseURL: urlApi,
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosInstance.interceptors.request.use(
    (config) => {
        const { apiToken } = store.getState().auth;

        if (apiToken) {
            config.headers['Authorization'] = `Bearer ${apiToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const xdMiniGameApi = {
    getToken(payload: { password: string; rememberMe?: boolean; username: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosInstance.post('/api/authenticate', payload);
    },
    getRank(params: { type: number; access_token: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        return axios.get(`${urlApi}/gamemini/api/xocdia/ranking`, {
            params,
        });
    },
    getStatistic(): Promise<AxiosResponse<BaseResponse<any>>> {
        return axios.get(`${urlApi}/gamemini/api/latest100results`);
    },
    getHistoryMyBet(params: { page: number; size: number; sort: string }): Promise<AxiosResponse<BaseResponse<any>>> {
        return axiosInstance.post('/api/tx/lichsucuoc', {}, { params });
    },
};
export default xdMiniGameApi;
